import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    padding: '4rem',
    backgroundColor: '#fff',
    borderRadius: '0.25em',
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06);',
  },
  breadcrumb: {
    margin: '8rem auto 1rem auto',
  },
  label: {
    color: `${theme.violet} !important`,
    fontWeight: 'bold',
  },
  value: {
    color: `#767676 !important`,
  },
  button: {
    margin: '1rem .75rem !important',
    backgroundColor: `${theme.violet} !important`,
    borderRadius: '1.5rem !important',
    color: '#fff !important',
    fontSize: '.8rem !important',
    padding: '0.5rem 1.25rem !important',
    fontWeight: '500 !important',
    lineHeight: '1.25rem !important',

    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
});

export default styles;
